import React from "react";

const auditRows = [
  {
    from: "February 5, 2026",
    to: "February 26, 2026",
    opening: "47 kgs",
    deposit: "0 kgs",
    withdrawals: "8 kgs",
    closing: "39 kgs",
    pdf: "/assets/pdf/ComTech FZCO - Gold Stock as on 26th February 2026.pdf",
  },
  {
    from: "January 29, 2026",
    to: "February 5, 2026",
    opening: "57 kgs",
    deposit: "0 kgs",
    withdrawals: "10 kgs",
    closing: "47 kgs",
    pdf: "/assets/pdf/ComTech FZCO - Gold Stock as on 5th February 2026.pdf",
  },
  {
    from: "September 17, 2025",
    to: "January 29, 2026",
    opening: "62 kgs",
    deposit: "0 kgs",
    withdrawals: "5 kgs",
    closing: "57 kgs",
    pdf: "/assets/pdf/ComTech FZCO - Gold Stock as on 29th January 2026.pdf",
  },
  {
    from: "August 27, 2025",
    to: "September 17, 2025",
    opening: "84 kgs",
    deposit: "0 kgs",
    withdrawals: "22 kgs",
    closing: "62 kgs",
    pdf: "/assets/pdf/ComTech FZCO - Gold Stock as on 17th September 2025.pdf",
  },
  {
    from: "March 21, 2025",
    to: "August 27, 2025",
    opening: "111 kgs",
    deposit: "0 kgs",
    withdrawals: "27 kgs",
    closing: "84 kgs",
    pdf: "/assets/pdf/ComTech FZCO - Gold Stock as on 27th Aug 2025.pdf",
  },
  {
    from: "October 12, 2023",
    to: "March 21, 2025",
    opening: "144 kgs",
    deposit: "29 kgs",
    withdrawals: "62 kgs",
    closing: "111 kgs",
    pdf: "/assets/pdf/Audit_file_21032025.pdf",
  },
  {
    from: "March 09, 2023",
    to: "October 11, 2023",
    opening: "141 kgs",
    deposit: "3 kgs",
    withdrawals: "0 kgs",
    closing: "144 kgs",
    pdf: "/assets/pdf/Routine_audit.pdf",
  },
  {
    from: "January 05, 2023",
    to: "March 08, 2023",
    opening: "124 kgs",
    deposit: "17 kgs",
    withdrawals: "0 kgs",
    closing: "141 kgs",
    pdf: "/assets/pdf/Download6.pdf",
  },
  {
    from: "Aug 31, 2022",
    to: "January 04, 2023",
    opening: "122 kgs",
    deposit: "2 kgs",
    withdrawals: "0 kgs",
    closing: "124 kgs",
    pdf: "/assets/pdf/Download5.pdf",
  },
  {
    from: "July 13, 2022",
    to: "Aug 30, 2022",
    opening: "121 kgs",
    deposit: "1 kgs",
    withdrawals: "0 kgs",
    closing: "122 kgs",
    pdf: "/assets/pdf/Download4.pdf",
  },
  {
    from: "June 07, 2022",
    to: "July 12, 2022",
    opening: "104 kgs",
    deposit: "17 kgs",
    withdrawals: "0 kgs",
    closing: "121 kgs",
    pdf: "/assets/pdf/Download3.pdf",
  },
  {
    from: "May 26, 2022",
    to: "June 06, 2022",
    opening: "100 kgs",
    deposit: "4 kgs",
    withdrawals: "0 kgs",
    closing: "104 kgs",
    pdf: "/assets/pdf/Download2.pdf",
  },
];

const Routine = () => {
  return (
    <div>
      <section className="pt-4 pb-4 tokenized_gold">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9 mb-4">
              <div className="main_title">
                <h2 className="h2 text-primary">Routine Audits</h2>
                <h3 className="h3 text-secondary">
                  Regular Audit reports from custodian.
                </h3>
              </div>
            </div>
            <div className="col-12">
              <div className="table-responsive mt-5 mb-5 bg-primary-dark gold_pattern">
                <table className="table table-dark">
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: "15%" }}>
                        From
                      </th>
                      <th scope="col" style={{ width: "15%" }}>
                        To
                      </th>
                      <th scope="col">Opening Balance</th>
                      <th scope="col">Deposit</th>
                      <th scope="col">Withdrawals</th>
                      <th scope="col"> Closing Balance</th>
                      <th scope="col">Vaulting Report</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan="7"> </td>
                    </tr>
                    {auditRows.map((row, index) => (
                      <React.Fragment key={`${row.from}-${row.to}`}>
                        <tr>
                          <td className="text-center">{row.from}</td>
                          <td className="text-center">{row.to}</td>
                          <td className="text-center">{row.opening}</td>
                          <td className="text-center">{row.deposit}</td>
                          <td className="text-center">{row.withdrawals}</td>
                          <td className="text-center">{row.closing}</td>
                          <td className="text-center">
                            <a
                              href={row.pdf}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-outline-primary"
                            >
                              Download
                            </a>
                          </td>
                        </tr>
                        {index < auditRows.length - 1 && (
                          <tr>
                            <td colSpan="7" className="p-0">
                              <img
                                className="w-100"
                                src="assets/images/footer_line.png"
                                alt=""
                              />
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                    <tr>
                      <td colSpan="7" className="p-0">
                        <img
                          className="w-100"
                          src="assets/images/footer_line.png"
                          alt=""
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Routine;
